import request from '../utils/request.js'
export const pre_datemotion=(imei)=>{
    return request({
        url:'/client/preDatemotion',
        method:'post',
        data:{
			imei
        }
    })
}
export const data_information=(imei)=>{
    return request({
        url:'/client/information',
        method:'post',
        data:{
            imei
        }
    })
}
export const emotion_identify=(phone)=>{
    return request({
        url:'/client/emotion_identify',
        method:'post',
        data:{
            phone
        }
    })
}
export const identify_list=(phone)=>{
    return request({
        url:'/client/identify_list',
        method:'post',
        data:{
			phone
		}
    })
}
export const identify_SEC=(data,time,phone,imei,type='')=>{
    return request({
        url:'/client/identify_SEC',
        method:'post',
        data:{
			identifyArr:data,
			time,phone,imei,type
		}
    })
}
export const minutes_identify=(imei)=>{
    return request({
        url:'/client/minutes_identify',
        method:'post',
        data:{
            imei
        }
    })
}
export const history_identify=(phone)=>{
    return request({
        url:'/client/history_identify',
        method:'post',
        data:{
            phone
        }
    })
}
export const describe=()=>{
    return request({
        url:'/client/describe',
        method:'get',
    })
}
export const hour_identify=(imei,time)=>{
    return request({
        url:'/client/hour_identify',
        method:'post',
        data:{
            imei,
            time
        }
    })
}
export const recommend_identify=(phone)=>{
    return request({
        url:'/client/recommend_identify',
        method:'post',
        data:{
            phone
        }
    })
}